import type { CategoryInfo } from "../../common/types/categoryTypes";

import MegaMenuCol from "./MegaMenuCol";

type MegaMenuProps = {
   cat: CategoryInfo;
   onHide: () => void;
};

const MegaMenu = ({ cat, onHide }: MegaMenuProps) => (
   <div className="flex w-full flex-row justify-between px-12 pt-4">
      {cat.children.map((subcat, index) => (
         <MegaMenuCol columnIndex={index} key={subcat.url_key} cat={subcat} productsUrl={cat.fullUrl} onClick={() => onHide()} />
      ))}
   </div>
);

export default MegaMenu;
